<template>
  <mt-tabbar v-model="selected" fixed>
    <mt-tab-item id="index" class="footer-tab-item" >
      <img slot="icon" src="../../assets/footer/icon-index-selected.png" v-if="selected==='index'">
      <img slot="icon" src="../../assets/footer/icon-index-unselected.png" v-if="selected!=='index'">
      首页
    </mt-tab-item>
    <mt-tab-item id="customerCart" class="footer-tab-item">
      <img slot="icon" src="../../assets/footer/icon-shopping-car-selected.png" v-if="selected==='customerCart'">
      <img slot="icon" src="../../assets/footer/icon-shopping-car-unselected.png" v-if="selected!=='customerCart'">
      购物车
    </mt-tab-item>
    <mt-tab-item id="mine" class="footer-tab-item" >
      <img slot="icon" src="../../assets/footer/icon-mine-selected.png" v-if="selected==='mine'" >
      <img slot="icon" src="../../assets/footer/icon-mine-unselected.png" v-if="selected!=='mine'" >
      我的
    </mt-tab-item>
  </mt-tabbar>
</template>

<script>
  import {Toast} from 'mint-ui';
  import session from '../../utils/Session'
  import Tools from '../../utils/Tools'

export default {
  name: 'my-footer',
  template: '#my-footer',
  data () {
    return {
      selected: 'index'
    }
  },
  beforeMount(){
    if (this.global.selectTab) {
      this.selected = this.global.selectTab;
      this.global.selectTab = '';
    }else {
      this.$router.replace('/index');
    }
    // }else {
    //   if(!session.getOpenId() && Tools.verfyBrowserType()){
    //     console.info('跳转登录页')
    //     this.$router.replace("/login");
    //   }else {
    //     this.$router.replace('/index');
    //   }
    // }
  },
  watch: {
    selected: function (value) {
      if (value === 'index') {
        this.global.selectTab = 'index';
        this.$router.replace('/index')
      } else if(value === 'community'){
        this.global.selectTab = 'community';
        window.location.href = 'http://exp.newsmth.net'
      } else if(value === 'customerCart'){
       this.global.selectTab = 'customerCart';
        this.$router.replace('/customer/cart')
      } else if(value === 'mine'){
        this.global.selectTab = 'mine';
        this.$router.replace('/mine')
      }
    }
  },
  methods: {
    comingSoon(){
      Toast('敬请期待');
    }
  }
}
</script>
<style type="text/css">
  .footer-tab-item{
    font-size: 0.22rem;
    color: #cecbca;
  }
  .mint-tab-item-icon{
    width: 0.54rem ;
    height: 0.54rem ;
  }
  .mint-tab-item{
    padding: 0.11rem 0;
  }
  .mint-tabbar{
    background: white;
    border-top: solid 1px #e0dedc;
  }
  .mint-tabbar > .mint-tab-item.is-selected{
    background: white;
    color: #feac00;
  }
</style>
